var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nav.length)?_c('nav',{staticClass:"c-nav-tab"},[_c('ul',_vm._l((_vm.nav),function(item){return _c('RouterLink',{key:item.name,attrs:{"to":item.route,"tag":"li","replace":""}},[_vm._v(" "+_vm._s(item.label || item.name)+" ")])}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }